export function extractIdFromIri(iri) {
  if (!iri) return null;

  try {
    const url = new URL(iri);
    const segments = url.pathname.split("/").filter(Boolean);
    return segments.at(-1) || null;
  } catch {
    const segments = String(iri).split("/").filter(Boolean);
    return segments.at(-1) || null;
  }
}
